import React, { Fragment, lazy } from "react";
import Label from "@controls/Label.js";
import { LinkNav } from "@controls/LinkNav.js";
const HydrationLoadScript = lazy(
  () => import("@controls/HydrationLoadScripts.js"),
);
const cssImporter = await import("@asyncImports/cssImporter.js").then(
  (mod) => mod.cssImporter,
);

const MenuItem = ({
  onClick,
  important,
  className,
  tran,
  children,
  category = null,
  href,
  style = null,
  hiddenOnMobile = false,
}) => {
  const attr = {};
  if (style) {
    attr["style"] = style;
  }
  if (onClick) {
    return (
      <li>
        <HydrationLoadScript
          postEvt={() => {
            cssImporter(className);
          }}
        />
        <button type="button" onClick={onClick} important={important}>
          <span {...attr} className={`ui-icon ${className}`}></span>
          {tran && (
            <Label
              category={category}
              className={hiddenOnMobile ? "hiddenOnMobile" : null}
              tranVal={tran}
            />
          )}
          {children ? <Fragment>&nbsp;&#9662;</Fragment> : <Fragment />}
        </button>
        {children}
      </li>
    );
  }
  return (
    <li>
      <LinkNav
        category={category}
        exact="true"
        to={href}
        important={important}
        tran={tran}
      >
        <HydrationLoadScript
          postEvt={() => {
            cssImporter(className);
          }}
        />
        <span {...attr} className={"ui-icon " + className}></span>
        {tran && <Label category={category} tranVal={tran} />}
        {children ? <Fragment>&nbsp;&#9662;</Fragment> : <Fragment />}
      </LinkNav>
      {children}
    </li>
  );
};
export default MenuItem;
